import { useParams, useSearchParams } from 'react-router-dom';
import { tabStyles } from '../../../../utils/helpers';
import { Tabs } from '@mantine/core';
import { Packmat } from './packmat';
import { Mother } from './mother';
import { useContext, useEffect, useState } from 'react';
import { axios } from '../../../../utils/axios';
import { CostingRequestsContext } from '../../../../contexts/CostingRequest';
import { transformItem } from './helper';
import { crRoles } from '../../../../constants';


const tabs = [
  {
    name: 'PACKMAT',
    value: 'packmat',
    component: (props) => <Packmat type={'packmat'} {...props} />,
    validator: () => true,
  },

  {
    name: 'MOTHER SKU',
    value: 'mother',
    component: (props) => <Mother {...props} />,
    validator: () => true,
  },

  {
    name: 'REPACK',
    value: 'repack',
    component: (props) => <Packmat type={'repack'} {...props} />,
    validator: (type) => type === 'Repack',
  },
];

export const BomComponentPrice = ({ activeTab, stepStatusKey }) => {
  const { crNumber } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState();
  const [skus, setSkus] = useState();
  const { info, isCrRoleAuthorized, crAssignedSpocs } = useContext(CostingRequestsContext);
  const [activePlant, setActivePlant] = useState();

  const activeSubTab = searchParams.get('subtab') || 'packmat';
  const { producing_plant_data = [], sku_data = [], costing_year, types_of_sku } = info;

  useEffect(() => {
    if (activeTab === 'bomComponentPrice' && sku_data.length && producing_plant_data.length) {
      const hasAccess = isCrRoleAuthorized(
        producing_plant_data[0]?.producing_plant,
        crRoles.procurement,
      );
      hasAccess ? fetch(true) : fetch(false);
      setActivePlant(producing_plant_data[0]?.producing_plant);
    }
  }, [activeTab, producing_plant_data, sku_data]);

  const fetch = async (refresh = false) => {
    try {
      setLoading(true);

      if (refresh) await axios.get(`costing-request/step/bom-component-refresh/${crNumber}`);
      const response = await axios.get(`/costing-request/step/bom-price/${crNumber}`);
      const data = response.data.data.map((item, i) => {
        return transformItem(item, costing_year,crAssignedSpocs);
      });
      setSkus(data);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tabs
        keepMounted={false}
        value={activeSubTab}
        onTabChange={(value) => setSearchParams({ tab: activeTab, subtab: value })}
        variant='unstyled'
        styles={tabStyles}
        className='prod-dev-tabs'
        color='#e5b611'
      >
        <Tabs.List>
          {tabs.map(
            (tab, index) =>
              tab.validator(types_of_sku) && (
                <Tabs.Tab
                  value={tab.value}
                  key={`bom_componnet_price_${index}`}
                  className='menu-tabs'
                >
                  {tab.name}
                </Tabs.Tab>
              ),
          )}
        </Tabs.List>

        {tabs.map(
          (tab, index) =>
            tab.validator(types_of_sku) && (
              <Tabs.Panel value={tab.value} key={`bom_componnet_price_content_${index}`}>
                {tab.component({
                  activeSubTab,
                  loading,
                  skus,
                  fetch,
                  activePlant,
                  setActivePlant,
                  stepStatusKey,
                })}
              </Tabs.Panel>
            ),
        )}
      </Tabs>
    </>
  );
};
